import { icons } from './icons';
import './index.css';

export default {
  name: 'AiconSelect',
  props: {
    size: { type: String, default: () => 'small' },
    value: { type: String, default: () => '' },
    placement: { type: String, default: () => 'bottom-start' },
    trigger: { type: String, default: () => 'click' },
    data: { type: Array | Boolean, default: () => [] },
    items: { type: Array | Boolean, default: () => false },
    option: { type: Array | Boolean, default: () => false },
    options: { type: Array | Boolean, default: () => false },
    fontSize: { type: String, default: () => '24' },
    unit: { type: String, default: () => 'px' || 'em' || 'rem' || 'vh' || 'vh' },
    placeholder: { type: String, default: () => '点击输入框选择图标' },
  },
  data() {
    return {
      list: [],
      content: '',
      visible: false,
    }
  },
  created() {
    this.create();
  },
  destroyed() {
    this.create = null;
    this.select = null;
    this.input = null;
  },
  methods: {
    create() {
      this.$nextTick(() => {
        const data = this.options || this.option || this.items || this.data || [];
        this.list = [...icons, ...data];
        this.$nextTick(() => {
          this.content = this.value;
        });
      });
    },
    select(content) {
      this.$nextTick(() => {
        this.input(content);
        this.$nextTick(() => {
          this.content = content;
          this.$nextTick(() => this.visible = false);
        });
      });
    },
    input(content) {
      this.content = content;
      this.$nextTick(() => this.$emit('input', this.content));
    },
    revoke() {

    },
  },
  render() {
    const { width = '480', height = '240px', ...attrs } = this.$attrs;
    return (
      <el-popover popper-class="a-icon-select" width={parseInt(width)} v-model={this.visible} placement={this.placement} trigger={this.trigger} {...{ attrs }}>
        <el-input slot="reference" clearable size={this.size} prefix-icon={this.content} v-model={this.content} on-input={this.input} placeholder={this.placeholder} />
        {this.list.length > 0 ? (
          <div class="a-icon-select-list" style={{ height }}>
            {this.list.map((a, b) => (
              <span key={b} class={['a-icon-select-item', (this.content == a ? 'active' : null)]} on-click={() => this.select(a)}>
                <i class={`a-icon-select-icon ${a}`} style={{ fontSize: this.fontSize.includes(this.unit) ? this.fontSize : `${this.fontSize}${this.unit}` }} />
              </span>
            ))}
          </div>
        ) : (<el-empty description="暂无数据" />)}
      </el-popover>
    );
  }
}